import { render, staticRenderFns } from "./ParametricHomeKnowledgeEditor.vue?vue&type=template&id=2447b26b&scoped=true&"
import script from "./ParametricHomeKnowledgeEditor.vue?vue&type=script&lang=js&"
export * from "./ParametricHomeKnowledgeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ParametricHomeKnowledgeEditor.scss?vue&type=style&index=0&id=2447b26b&prod&lang=scss&scoped=true&"
import style1 from "./ParametricHomeKnowledgeEditor.vue?vue&type=style&index=1&id=2447b26b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2447b26b",
  null
  
)

export default component.exports